import type { AuthFlow, AuthResponse, OriginName } from '~/interfaces/common';
import { createLoginHandler } from '~/services/login/factory';
import { createSignupHandler } from '~/services/signup/factory';
import { fetchJson } from '~/utils/fetch-json';
import { getLocalStorageItem } from '~/utils/local-storage';
import { redirectAfterAuth } from '~/utils/redirect-after-auth';

import type { AccountProfileData } from '../signup/-types/types';

export async function verifyOtpCode(
  originName: OriginName,
  alias: string,
  code: string,
) {
  const authFlow = getLocalStorageItem<AuthFlow>('authFlow');
  let res!: AuthResponse | null;

  if (authFlow === 'login') {
    const handler = createLoginHandler(originName);
    res = await handler.handle({
      alias: alias,
      assert: {
        phone: alias,
        email: alias,
        code,
      },
    });
  }

  let usage: string | undefined;
  if (authFlow === 'signup') {
    const data = getLocalStorageItem<AccountProfileData>('signup');
    if (!data) {
      throw new Error(
        'Ocurrio un error al obtener los datos de registro por OTP',
      );
    }

    const handle = createSignupHandler(originName);
    res = await handle.handle({
      assert: {
        phone: alias,
        email: alias,
        code,
      },
      data,
    });
    usage = data.usage;
  }

  if (!res) {
    return;
  }
  const token = res.result.access_token;

  if (usage) {
    await fetchJson('/identities/me', {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        metadata: {
          usage: usage,
        },
      }),
    });
  }

  redirectAfterAuth(token);
}
